export const categories = [
  {
    slug: 'grading-system',
    name: '分级制度',
    icon: 'ri-government-line',
    description: '深入解析香港电影三级制的起源、发展与现行标准，探讨分级制度对社会文化的影响。',
    color: 'accent',
    count: 6,
  },
  {
    slug: 'history',
    name: '历史演变',
    icon: 'ri-history-line',
    description: '从1988年三级制确立至今，梳理香港电影分级制度的发展历程与重要节点。',
    color: 'primary',
    count: 5,
  },
  {
    slug: 'representative-works',
    name: '代表作品',
    icon: 'ri-film-line',
    description: '精选影史上具有里程碑意义的三级片作品，从艺术与社会角度进行深度分析。',
    color: 'secondary',
    count: 8,
  },
  {
    slug: 'cultural-studies',
    name: '文化研究',
    icon: 'ri-lightbulb-line',
    description: '从社会学、文化学角度审视三级片在亚洲电影史中的地位与文化意义。',
    color: 'accent',
    count: 4,
  },
  {
    slug: 'censorship',
    name: '审查制度',
    icon: 'ri-shield-check-line',
    description: '对比香港、台湾及亚洲各地的电影审查标准与三级片管理机制。',
    color: 'primary',
    count: 5,
  },
  {
    slug: 'asian-classification',
    name: '亚洲电影分级',
    icon: 'ri-global-line',
    description: '横向比较亚洲各国电影分级制度，了解三级片在不同文化语境中的定位。',
    color: 'secondary',
    count: 6,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});